import React, { useContext } from "react";
import { PsychologistInitialContext } from "./PsychologistInitialAssessmentProvider";
import PsychologistPatientDemographicSummary from "../../InspectionSummaries/PatientDemographics/PsychologistPatientDemographicSummary";
import { Col, Row, Tag } from "antd";
import PsychologistPreviousCounsellingSummary from "../../InspectionSummaries/PreviousCounselling/PsychologistPreviousCounsellingSummary";
import PsychologistSymptomsSummary from "../../InspectionSummaries/Symptoms/PsychologistSymptomsSummary";
import PsychologyDiagnosisSummary from "../../InspectionSummaries/PsychologyDiagnosis/PsychologyDiagnosisSummary";
import PsychologistTherapySummary from "../../InspectionSummaries/Therapy/PsychologistTherapySummary";
import { checkEmpty } from "../../../../helpers/utility";
import dayjs from "dayjs";
import "../../summary.css";

const PsychologistInitialInspectionSummary = ({ hideMeta = false }) => {
  const { formData } = useContext(PsychologistInitialContext);

  return (
    <Row className="summaries" gutter={[16, 16]}>
      {!hideMeta && (
        <Col span={24}>
          <div className="ia-summary-meta-bar">
            {(formData?.submitted_by_first_name ||
              formData?.submitted_by_last_name) && (
              <Tag className="ia-summary-meta-tag ia-summary-meta-tag--submitted">
                Submitted by: {formData?.submitted_by_first_name || ""}{" "}
                {formData?.submitted_by_last_name || ""}
              </Tag>
            )}
            <div className="ia-summary-meta-bottom">
              {formData?.updated_at && (
                <Tag className="ia-summary-meta-tag ia-summary-meta-tag--updated">
                  Updated at:{" "}
                  {dayjs(formData?.updated_at).format("DD/MM/YYYY hh:mm A")}
                </Tag>
              )}
            </div>
          </div>
        </Col>
      )}
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.patient_demographics) && (
          <PsychologistPatientDemographicSummary formData={formData} />
        )}
        {checkEmpty(formData?.previous_counselling) && (
          <PsychologistPreviousCounsellingSummary formData={formData} />
        )}
        {checkEmpty(formData?.psychology_diagnosis) && (
          <PsychologyDiagnosisSummary
            formData={formData}
            context={PsychologistInitialContext}
          />
        )}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.symptoms) && (
          <PsychologistSymptomsSummary formData={formData} />
        )}

        {checkEmpty(formData?.therapies_suggested) && (
          <PsychologistTherapySummary
            formData={formData}
            context={PsychologistInitialContext}
          />
        )}
      </Col>
    </Row>
  );
};

export default PsychologistInitialInspectionSummary;
